// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3ARrC","modalQuestionWrapper":"styles_modalQuestionWrapper__mmKJm"};